import {
    browserSupportsWebAuthn,
    startRegistration,
    startAuthentication,
} from "@simplewebauthn/browser";


const isSupported = () => browserSupportsWebAuthn()

const Register = async (ApiService, existingList = []) => {
    const res = await ApiService.endpointApi.post("/users/add-passkey");
    const decodeChallenge = getDecodeChallenge(res.challenge);
    const optionsJSON = {
        ...decodeChallenge.publicKey,
    };
    try {
        const attResp = await startRegistration({ optionsJSON });
        return await confirmCreation(attResp, ApiService, existingList)
    } catch (error) {
        console.log("ERROR on Registering Passkey:", error);
    }
}

const confirmCreation = async (attResp, ApiService, existingList) => {
    const params = {
        alias: await getDeviceModel(existingList),
        authenticator_response: {
            id: attResp.id,
            rawId: attResp.id,
            response: attResp.response,
            type: "public-key",
        },
    };
    try {
        await ApiService.endpointApi.post(
            "/users/confirm-add-passkey",
            params
        );
        return { success: true}
    } catch (error) {
        console.error("Error:", error);
        return { success: false, error: error}
    }
};

const Sign = async (options) => {
    try {
        const response = await startAuthentication(options.publicKey)
        return btoa(JSON.stringify(response))
    } catch (e) {
        console.error(e)
    }
}

const getDecodeChallenge = (challengeString) => {
    try {
        const byteArray = Uint8Array.from(
            atob(challengeString.replace(/-/g, "+").replace(/_/g, "/")),
            (c) => c.charCodeAt(0)
        );
        const stringData = new TextDecoder().decode(byteArray);

        let jsonData;
        try {
            jsonData = JSON.parse(stringData);
        } catch (jsonError) {
            jsonData = stringData;
        }
        return jsonData;
    } catch (error) {
        console.error("Error processing challenge:", error);
        return null;
    }
};
async function getDeviceModel(existingList) {
    const displayName = "EMCD passkey";
    let suffix = "";

    if (Array.isArray(existingList) && existingList.length > 0) {
        const numbers = Math.floor(Math.random() * 90 + 10);
        const letters = String.fromCharCode(
            Math.floor(Math.random() * 26) + 65,
            Math.floor(Math.random() * 26) + 65
        );
        suffix = ` ${numbers + letters}`;
    }
    if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
        try {
            const data = await navigator.userAgentData.getHighEntropyValues([
                "platform",
            ]);
            return (data.platform || displayName) + suffix;
        } catch (err) {
            console.error("Error getting device model:", err);
            return displayName + suffix;
        }
    }
    return displayName + suffix;
}

const PasskeyService = {
    isSupported,
    Register,
    Sign,
};

export default PasskeyService;
